var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCastle = function SvgCastle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#461B14",
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 20C1 9.507 9.507 1 20 1s19 8.507 19 19-8.507 19-19 19S1 30.493 1 20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M28.589 18v8.461H11.468v-8.46m11.778 8.46v-8.455m-6.437 8.455v-8.455m1.637 8.256V22.85c0-.868.714-1.581 1.582-1.581s1.582.713 1.582 1.581v3.412m-8.318-6.602h1.703v1.78h-1.703zm0 3.367h1.703v1.781h-1.703zm7.67-4.357a.935.935 0 1 1-1.87 0 .935.935 0 0 1 1.87 0Zm4.585-5.486H14.509l-3.882 3.484V18h6.182l3.219-3.219 3.219 3.219h6.182v-1.333zm-.47 6.476h1.702v1.78h-1.703zm0 3.367h1.702v1.781h-1.703z"
  })));
};
export default SvgCastle;